<div
    class="privacy-policy-card"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <h4>
        Sigurnost :
    </h4>
    <span class="title fw-medium d-block">
        Postavke autentifikacije i autorizacije
    </span>
    <p>
        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of.
    </p>
    <span class="title fw-medium d-block">
        Sekundarna potvrda
    </span>
    <p>
        It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing.
    </p>
    <span class="title fw-medium d-block">
        Pomoćni kodovi
    </span>
    <p>
        Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of lorem ipsum.
    </p>
    <span class="title fw-medium d-block">
        Desktop, email, chat, purchase notifications
    </span>
    <p>
        It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters.
    </p>
    <span class="title fw-medium d-block">
        Obrišite ovaj korisnički račun:
    </span>
    <p>
        There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.
    </p>
    <div class="btn-box">
        <button mat-button>
            Zatvorite i obrišite ovaj korisnički račun
        </button>
        <button mat-button>
            Odustanite
        </button>
    </div>
</div>